export default "__VITE_ASSET__DFiotCzJ__"